import React from "react";
import TransactionListASAP from "./TransactionListASAP"

export default class Purchase extends React.Component {

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        localStorage.setItem('TransactionType', JSON.stringify(2));
    }

    render() {
        return (
            <div>
                <TransactionListASAP type={2} history={this.props.history}></TransactionListASAP>
            </div >
        );
    }
}

